import { ca } from '@cian/analytics';

const trackRewardInstructionClick = (modalStep: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'PopUpReward',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        modal_step: modalStep,
      },
    },
    useLastProducts: true,
  });
};

export const trackRewardInstructionLinkClick = () => trackRewardInstructionClick('first');

export const trackRewardInstructionButtonClick = () => trackRewardInstructionClick('second');
